export enum GlobalMutations {
  SET_COUNTRIES = "SET_COUNTRIES",
}
